import { z } from "zod";

export const FirebasePushIdSchema = z
  .string()
  .regex(
    new RegExp(
      "^[-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz]{20}$",
    ),
  );
